import { setLoading, showSnackbar } from 'reducers/ui';
import { errorHandler } from 'utils/errorMessages';
import { call, put, takeLatest } from 'redux-saga/effects';
import get from 'lodash/get';
import {
  companyActions,
  companySelectors,
} from 'containers/Pages/Region/Companies';
import API from 'services/api';
import { select } from '@redux-saga/core/effects';

export function* fetchCompaniesListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { filters, from } = payload;
    const { data } = yield call(API.fetchSecurityCompanies, {
      ...filters,
      from,
    });
    if (data.data != null) {
      const totalEntries = get(data, 'meta.total');
      yield put(companyActions.setGridList({ list: data.data, totalEntries }));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* fetchCompanyDetailsSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;
    //select from the state
    const rows = yield select(companySelectors.getCompanyList);
    const value = rows.find(f => f.id === id);
    if (value) {
      yield put(companyActions.setGridRowDetails({ details: value }));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* companySagas() {
  yield takeLatest(companyActions.fetchGridList, fetchCompaniesListSaga);
  yield takeLatest(companyActions.fetchGridRowDetails, fetchCompanyDetailsSaga);
}
